// Credentials live in the dashboard file and travel through the bridge in clear (decision §12), so
// every message a host logs or reports back is passed through this first. It removes what is
// recognisably a credential; it cannot know a password that appears on its own.

const URL_USERINFO = /([a-z][a-z0-9+.-]*:\/\/)[^\s/@]+@/gi;
const AUTH_SCHEME = /\b(basic|bearer|token|digest)\s+[A-Za-z0-9._~+/=-]+/gi;
const HEADER_VALUE = /\b(authorization|proxy-authorization|cookie|set-cookie|x-api-key)(["']?\s*[:=]\s*["']?)(?:(?:basic|bearer|token|digest)\s+)?[^\s"',;]+/gi;
const QUERY_SECRET = /([?&](?:access_token|token|apikey|api_key|key|password|pass|secret|auth)=)[^&\s#"']+/gi;

const MASK = '***';

/** `text` with credentials in URLs, authorization values and secret-looking query parameters masked. */
export function redactCredentials(text: string) : string {
    return text
        .replace(URL_USERINFO, `$1${MASK}@`)
        .replace(HEADER_VALUE, `$1$2${MASK}`)
        .replace(AUTH_SCHEME, `$1 ${MASK}`)
        .replace(QUERY_SECRET, `$1${MASK}`);
}
